<template>
	<div class='a-tourist-list'>
		<template v-for='(section, s) in sections'>
			<p class='a-tourist-list-room' :key='`room-${s}`' v-if='section.title'>{{section.title}}</p>
			<div class="a-tourist-list-col" v-for='entry in section.items' :key='entry.index'>
				<a-user
					:user='entry.item'
					:index="entry.index"
					:subTitle="`${entry.item.type === 'children' ? (entry.item.age === 0 ? $t('account.declOfNum.up_to_1_year') : `${entry.item.age} ${$helpers.declOfNum(entry.item.age, $t('account.declOfNum.years'))}`) : ''}`"
					isBorder
				>
					<template v-slot:action>
						<div class='a-user--action ml-auto' v-if='isDelete'>
							<div class='a-user--action--btn' @click='$emit("remove-tourist", entry.index)'>
								<v-icon icon='cross' size='12' />
							</div>
						</div>
					</template>
				</a-user>
			</div>
		</template>
	</div>
</template>

<script>
	export default {
		props: {
			items: {
				type: Array,
				default: () => []
			},
			isDelete: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			sections() {
				// группируем только при нескольких номерах — для одного заголовок не нужен
				let roomIndexes = new Set(this.items.filter(el => el.roomIndex !== null && el.roomIndex !== undefined).map(el => el.roomIndex));
				if(roomIndexes.size < 2) return [{title: null, items: this.items.map((item, index) => ({item, index}))}];

				let groups = {};
				this.items.forEach((item, index) => {
					let key = item.roomIndex ?? 'none';
					(groups[key] = groups[key] ?? []).push({item, index});
				});
				return Object.keys(groups)
					.sort((a, b) => (a === 'none') - (b === 'none') || a - b)
					.map(key => ({
						title: key === 'none' ? null : this.$t('account.booking.content.room_number', {n: +key + 1}),
						items: groups[key]
					}));
			}
		}
	}
</script>

<style lang="scss">
	@import "@/styles/global/variables";
	@import "@/styles/global/mixins";

	.a-tourist-list {
		display: contents;
		&:not(.a-tourist-list-contents) {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
		}
		&-col {
			padding-right: 5px;
			padding-left: 5px;
			margin-bottom: 16px;
			@include maxw( $grid-breakpoints-xs - 1 ) {
				width: 100%;
				margin-bottom: 10px;
			}
		}
		&-room {
			flex: 0 0 100%;
			max-width: 100%;
			font-size: 14px;
			font-weight: 700;
			padding: 0 5px;
			margin-bottom: 10px;
			&:not(:first-child) {
				margin-top: 6px;
			}
		}
	}

</style>
